import { atom } from 'jotai';
import { S2Mosaic_GetPage_ResponseItem } from '~/common/typescript/apis/S2MosaicAPIs';

export const s2mosaicItemsLEFTAtom = atom<S2Mosaic_GetPage_ResponseItem[]>([]);

export const s2mosaicItemsRIGHTAtom = atom<S2Mosaic_GetPage_ResponseItem[]>([]);

export const s2mosaicLoadingAtom = atom<{
  isLoading: boolean;
  text: string;
}>({
  isLoading: false,
  text: '',
});

